import { Link, useNavigate } from 'react-router-dom';
import { Button, Card } from '@dreamtree-org/twreact-ui';
import { ChevronRight } from 'lucide-react';
import { EmptyState, Money, PageHeader, QueryState, StatusBadge } from '@/components';
import { useQuery } from '@/lib/useQuery';
import { formatDate } from '@/lib/format';
import { useStorefront } from '../StorefrontContext';
import UnitImage from '../components/UnitImage';

/** WEB-07 order list. */
export default function Orders() {
  const sf = useStorefront();
  const navigate = useNavigate();
  const q = useQuery('sfOrders', { seller: sf.seller.name }, { select: (r) => r.data });
  return (
    <div className="space-y-4">
      <PageHeader title="My orders" back={{ label: 'Account', href: '/account' }} />
      <QueryState query={q}>
        {(orders) =>
          !orders.length ? (
            <EmptyState title="No orders yet" action={<Button onClick={() => navigate('/shop')}>Browse the shop</Button>}>Orders you place will appear here.</EmptyState>
          ) : (
            <div className="space-y-3">
              {orders.map((o) => (
                <Link key={o.id} to={`/account/orders/${o.id}`} className="block">
                  <Card hover className="flex items-center gap-3 p-3 sm:p-4">
                    <UnitImage size="sm" className="aspect-square w-16 shrink-0 sm:w-20" label={o.items[0] && o.items[0].title} icon={(o.items[0] && (sf.shop.typeOf(o.items[0]) || {}).icon) || undefined} />
                    <div className="min-w-0 flex-1 space-y-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="font-semibold">{o.id}</span>
                        <StatusBadge status={o.status} size="xs" />
                      </div>
                      <div className="truncate text-sm">{o.items.map((i) => (i.qty > 1 ? `${i.title} × ${i.qty}` : i.title)).join(', ')}</div>
                      <div className="text-xs opacity-70">
                        Placed {formatDate(o.placed_at)} · <Money paise={o.totals.total_paise} /> · {o.seller.name}
                      </div>
                    </div>
                    <ChevronRight className="h-5 w-5 shrink-0 opacity-50" aria-hidden="true" />
                  </Card>
                </Link>
              ))}
            </div>
          )
        }
      </QueryState>
    </div>
  );
}
